import { Colors } from 'types/theme'

export const colors: Colors = {
    dark: '#0D1821',
    twoDark: '#21212b',
    blue: '#047FFD',
    darkGrey: '#A2A7A5',
    grey: '#5B5B5B',
    lightGrey: '#F9F9F9',
    purple: '#704FDC',
    lightDark: '#182632',
    lineaGradiant:
        'linear-gradient(93.85deg, #047FFD 14.11%, #704FDC 99.05%),' +
        'linear-gradient(0deg, #0D1821, #0D1821)',
    mainGradient: 'linear-gradient(93.85deg, #047FFD 14.11%, #704FDC 99.05%)',
    headerGradient:
        'linear-gradient(90.14deg, rgba(249, 249, 249, 0.65) 0.87%, rgba(249, 249, 249, 0.58) 100%);',
    white: '#ffffff',
    lightWhite: '#fbfdff',
    whiteLight: '#F2F2F2',
    primary: '#782bc5',
    footerPrimary: '#3d0a71',
    second: '#0971E4',
    greyPrimary: '#cfcfcf',
    grewSecond: '#797979',
    testimonialDark: 'rgba(0, 0, 0, 0.34)',
    greyLight: '#959595',
    background: '#1E1E1E',
    hamburger: 'rgba(0, 0, 0, 0.66)',
    carousel: 'rgba(106, 106, 106, 0.53)',
    fontImage: '#C9C9C9',
    primaryWhite: 'rgb(175,90,253)',
    danger: '#FF0000FF',
}
